import { Editor } from 'slate';

export default function isEditorEmpty(editor) {
  if (!editor || !editor.children || !editor.children.length) {
    return true;
  }

  // Try to find a text node that has a non-whitespace character in it
  let { done: hasNoText } = Editor.nodes(editor, {
    at: [],
    match: n => n.text && /\S/g.test(n.text),
  }).next();
  return hasNoText;
}
